import $ from 'jquery'
import Splide from '@splidejs/splide'

if ( $('.js-cities-slider').length != 0 ) {
    var citiesSplide = new Splide( '.js-cities-slider', {
        drag   : 'free',
        arrows: false,
        pagination: false,
        fixedWidth : '275px',
        fixedHeight : '275px',
        gap : '5px',
        destroy: true,
        breakpoints: {
            992: {
                destroy: false,
            },
        }
    } );

    citiesSplide.mount();
}
